import { Icons } from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

import { HpaSettingsTabChip } from '../../_components/HpaSettingsTabChip';
import { useHpaV2Status } from '../../_hooks/useHpaV2Status';
import {
  isHpaV2UnavailableOnTakeOwnership,
  isHpaV2UnavailableOnWorkloadType,
  workloadHasNativeHpaSettings,
  workloadOwnershipWasTaken,
} from '../../_utils';

export const RightsizingHpaSettingsTabChips = ({
  workload,
  isHpaSettingsMissingOnWorkloadForm,
  workloadHasLegacyHpaSettings,
}: {
  workload: PreparedWorkload | undefined;
  isHpaSettingsMissingOnWorkloadForm: boolean;
  workloadHasLegacyHpaSettings: boolean;
}) => {
  const { hpaV2Status } = useHpaV2Status();

  if (hpaV2Status === 'outdated') {
    return (
      <HpaSettingsTabChip
        icon={<Icons.Warning size={12} />}
        label="OUTDATED"
        color="warning"
      />
    );
  }

  if (hpaV2Status !== 'available') {
    return null;
  }

  if (workload?.verticalScalingPolicy?.isCastware) {
    return (
      <HpaSettingsTabChip
        testId="hpa-settings-not-available-chip"
        label="N/A"
      />
    );
  }

  if (isHpaV2UnavailableOnWorkloadType(workload)) {
    return (
      <HpaSettingsTabChip
        icon={<Icons.Question size={12} weight="bold" />}
        label="NOT SUPPORTED"
      />
    );
  }

  if (workload && workloadHasNativeHpaSettings(workload)) {
    if (isHpaV2UnavailableOnTakeOwnership(workload)) {
      return (
        <HpaSettingsTabChip
          icon={<Icons.WarningCircle size={12} weight="bold" />}
          label=""
          color="warning"
        />
      );
    }

    if (!workloadOwnershipWasTaken(workload)) {
      return null;
    }
  }

  // Show MISSING chip if HPA settings are missing AND workload doesn't have legacy HPA
  if (
    isHpaSettingsMissingOnWorkloadForm &&
    workload &&
    !workloadHasLegacyHpaSettings
  ) {
    return (
      <HpaSettingsTabChip
        icon={<Icons.Question size={12} weight="bold" />}
        label="MISSING"
      />
    );
  }
  return null;
};
